//@flow

// Vendors
import React from 'react';

// Components
import { Modal } from '..';
import { ReactComponent as LockoutSVG } from '../../../../assets/lockout.svg';
import Content from '../../Content/Content';



// Styles
import './accountDisabled.scss';

const AccountDisabled = () => (
    <Modal name="AccountDisabled" className="modal-sm lockout-modal">
      <h2 className="h1 modal-title">
        Account Disabled.
      </h2>
      <div className="modal-content">
        <div className="modal-graphic">
          <LockoutSVG role="presentation" />
        </div>
        <p>
          To protect your personal Information, your account has been disabled.
        </p>
        <p>
          Please contact your administrator
        </p>
      </div>
    </Modal>
  );



export default AccountDisabled;
